import * as t from './types'
import { v4 as uuidv4 } from 'uuid';
import { register as registerMontecarlo } from './montecarlo';

///////////////////////////////////////////////////////////////////////////////
// State
///////////////////////////////////////////////////////////////////////////////

const services = new Map<t.WorkerAction, t.TaskHandler>();
const tasks = new Map<t.RequestId, Worker>();

registerMontecarlo();

///////////////////////////////////////////////////////////////////////////////
// Public Functions
///////////////////////////////////////////////////////////////////////////////

export function registerService(
  action: t.WorkerAction,
  handler: t.TaskHandler,
): void {
  if (services.has(action)) {
    throw new Error(`${t.WorkerAction[action]} is already registered.`);
  }

  services.set(action, handler);
}

export function getService(action: t.WorkerAction): t.TaskHandler {
  if (!services.has(action)) {
    throw new Error(`Action: ${action} not found in service registry`);
  }

  return services.get(action)!;
}

export function setTask(worker: Worker): t.RequestId {
  const requestId: t.RequestId = uuidv4();
  tasks.set(requestId, worker);
  return requestId;
}

export function cancelTask(requestId: t.RequestId): void {
  if (tasks.has(requestId)) {
    const worker = tasks.get(requestId)!;
    worker?.terminate();
    tasks.delete(requestId);
    console.log(`cancelled task ${requestId}`);
  } else {
    console.log(`worker.client.cancelTask not found: ${requestId}`);
  }
}